<div class="container-fluid bg-white entity">

  <app-loader *ngIf="isLoading()"></app-loader>

  <div class="page" *ngIf="!isLoading()">

    <div class="page-body">

      <div class="container-section">

        <div class="container-smaller">

          <div class="content-wrapper">

            <div class="content">

              <div class="entity-single">

                <div class="row">

                  <div class="col-12 col-sm-7 column-left">

                    <h1 class="page-title entity-title alternate-heading">
                      {{getTranslatedTitle(entity)}}
                    </h1>

                    <span class="entity-content" [innerHTML]="getTranslatedContent(entity) | safeHtml"></span>

                  </div>

                  <div class="col-12 col-sm-5 column-right">

                    <div class="image-main entity-image-main">
                      <img class="img-fluid" [src]="entity.imageUri" />
                    </div>

                    <!-- image gallery thumbnails -->
                    <div class="image-thumbnails-wrapper" *ngIf="entity.imageReferences && entity.imageReferences.length>0">
                      <div class="row">
                        <div class="col-sm-6 cursor-pointer" [ngClass]="{'d-none': image['imageType'] != externalpageImageTypes.GalleryImage}" *ngFor="let image of entity.imageReferences" (click)="imageService.openImage(image.imageUri, entity.title)">
                          <img class="img-fluid image-thumb" [src]="image['imageUri']" />
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>

              <div class="entity-related mt-4">

                <h3 class="alternate-heading text-center mb-4">
                  <span class="text-primary">{{'More' | translate}}</span> {{'news' | translate}}
                </h3>

                <div class="grid grid-blogpost">

                  <div class="row">

                    <div class="col-6 col-sm-4 grid-item grid-item-blogpost grid-item-image-bg" *ngFor="let node of relatedData()">

                      <a class="grid-item-link" [routerLink]="'/blog/' + (node.permalink ? node.permalink : node.id)">

                        <div class="grid-item-image-wrapper" *ngIf="node.imageUri" [ngStyle]="{'background-image' : 'url(' + (node.imageUri ? node.imageUri : '') + ''}">
                          <img class="grid-item-image grid-item-image-blogpost img-fluid" [src]="node.imageUri" />
                        </div>

                        <h3 class="grid-item-title">
                          {{getTranslatedTitle(node)}}
                        </h3>
                      </a>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>

